export default __webpack_public_path__ + "static/media/frente-casa2.c6938d55.jpg";